import React from 'react';
import { SimpleCarousal } from '../../Atoms/Carousel';
import { handleTrack } from '../../../utils/tracker';
import {
  TestimonialCardData,
  TrustedByExpertsBusinessesSectionProps,
} from '../types';
import TestimonialCard from './testimonial-card';
import SectionHeading from '../common/section-heading-component';
import {
  PartnerNextArrow,
  PartnerPrevArrow,
} from '../../partner-pages/partner-carousel/utils';

const TrustedByExpertsBusinessesSection: React.FC<
  TrustedByExpertsBusinessesSectionProps
> = ({ testimonials }) => {
  const handleTestimonialClick = (
    card: TestimonialCardData,
    event: React.MouseEvent
  ) => {
    handleTrack({
      label: `fold_Testimonials_button_${card.fold}`,
      obj: event.target,
    });
  };

  return (
    <section className="py-8 xl:py-24 lg:py-24 md:py-24 wg-container sm:pb-10">
      <SectionHeading
        heading="Trusted by experts and businesses"
        classname="mb-8"
      />

      <SimpleCarousal
        slidesToShow={2.5}
        autoplay={true}
        infinite={true}
        slidesToScroll={1}
        arrows={true}
        dots={false}
        adaptiveHeight={true}
        mediumScreen={{
          slidesToShow: 2,
        }}
        mobile={{
          dots: false,
          arrows: true,
          centerMode: false,
          slidesToScroll: 1,
          slidesToShow: 1,
          infinite: true,
          autoplay: true,
        }}
        customArrows={{
          customNextArrow: <PartnerNextArrow variant={'topRight'} />,
          customPrevArrow: <PartnerPrevArrow variant={'topRight'} />,
        }}
      >
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            card={testimonial}
            onCardClick={handleTestimonialClick}
          />
        ))}
      </SimpleCarousal>
    </section>
  );
};

export default TrustedByExpertsBusinessesSection;
